module.exports = __webpack_public_path__ + "static/media/JD_AM_Corp Sal.fd4c20f5.pdf";